import { CalendarEventOperationResult } from 'owa-calendar-events-store';

export async function wrapInCalendarEventOperationResult<T>(
    func: () => Promise<T>
): Promise<CalendarEventOperationResult> {
    try {
        await func();
        return {
            isSuccessful: true,
        };
    } catch (error) {
        return {
            isSuccessful: false,
        };
    }
}
